(function() {
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("9744Q", function(module, exports) {
    if (customElements.get("image-block")) return;
    class ImageBlock extends HTMLElement {
      constructor() {
        super();
        this._toggle = this.querySelector("[data-read-more-toggle]");
        this._onToggleClick = null;
      }
      connectedCallback() {
        if (!this.classList.contains("image-block--overlaid")) return;
        if (!this._toggle) return;
        this._onToggleClick = event => {
          event.preventDefault();
          this.toggleExpand();
        };
        this._toggle.addEventListener("click", this._onToggleClick);
      }
      disconnectedCallback() {
        if (this._toggle && this._onToggleClick) this._toggle.removeEventListener("click", this._onToggleClick);
      }
      toggleExpand(force = null) {
        const isExpanded = force !== null ? force : this.classList.toggle("is-expanded");
        if (force !== null) this.classList.toggle("is-expanded", force);
        if (!this._toggle) return isExpanded;
        const readMore = this._toggle.dataset.readMore || window.MBF?.strings?.readMore;
        const readLess = this._toggle.dataset.readLess || window.MBF?.strings?.readLess;
        if (readMore && readLess) this._toggle.textContent = isExpanded ? readLess : readMore;
        this._toggle.setAttribute("aria-expanded", String(isExpanded));
        return isExpanded;
      }
    }
    customElements.define("image-block", ImageBlock);
  });
  parcelRequire("9744Q");
})();